import {api, request} from '../../../utilities';


export async function expense( signal, values ) {
    const { student, house_meal, finance, additional } = values
    const { residency, classification, classification_specific, studyArea, credits, techDropdown } = student
    const { housingType, buildingName, roomType, roomFeature, mealPlan } = house_meal
    const { grants, scholarships, loans } = finance

    const tuition_n_fees = await getCostUsingApi( signal,
        [
            {
                name: "Tuition",
                api: 'fees/tuition',
                // Notice that anywhere with credits as param I replaced with '(classification === 3 && credits > 9)? 9 :credits' to enable credits consider graduates, cause of graduate max is 9.
                params: {id1:(classification === 3 && credits > 9)? 9 :credits, id2:residency, id3:classification, id4:studyArea},
                semester: "Both"
            },
            {
                name: "Activity Fee",
                api: 'fees/activity',
                params: {id1:(classification === 3 && credits > 9)? 9 :credits, id2:classification},
                semester: "Both"
            },
            {
                name: "Health Fee",
                api: 'fees/health',
                params: {id:(classification === 3 && credits > 9)? 9 :credits},
                semester: "Both"
            },
            {
                name: "Health Facility Fee",
                api: 'fees/general-fees',
                params: {id: 0},
                semester: "Both"
            },
            {
                name: "Tech Fee",
                api: 'fees/tech',
                params: {id1:classification, id2: techDropdown, id3: (classification === 3 && credits > 9)? 9 : credits },
                semester: "Both"
            },
            {
                name: "Records Fee",
                api: 'fees/general-fees',
                params: {id: 3},
                semester: "Fall",
                when:  classification === 1 || classification_specific === 'first-year'
            },
        ])

    const housing_n_meal = await getCostUsingApi( signal,
        [
            {
                name: "",
                name_api: 'fees/housingName',
                name_params: {id1:housingType, id2:buildingName, id3:roomType, id4: roomFeature},
                api: 'fees/housingCost',
                params: {id1:housingType, id2:buildingName, id3:roomType, id4: roomFeature},
                semester: "Both"
            },
            {
                name: "",
                name_api: 'fees/mealName',
                name_params: {id: mealPlan}, 
                api: 'fees/mealCost',
                params: {id: mealPlan},
                semester: "Both"
            },
            {
                name: "Hall Dues",
                api: 'fees/general-fees',
                params: {id: 1},
                semester: "Fall",
                when: housingType && housingType !== 4 
            },
            {
                name: "Inter-residence Hall Dues",
                api: 'fees/general-fees',
                params: {id: 2},
                semester: "Fall",
                when:  housingType && housingType !== 4 
            },
        ])

    const other_expenses = await getCostUsingArray(
        [
            {
                name: "Additional",
                arr: additional
            },
        ])

    const financial_aid = await getCostUsingArray(
        [
            {
                name: "Grants",
                arr: grants
            },
            {
                name: "Scholarships",
                arr: scholarships
            },
            {
                name: "Loans",
                arr: loans
            },
        ])

    const total=[
        {
            name: "Subtotal",
            fall: tuition_n_fees[0].fall + housing_n_meal[0].fall + other_expenses[0].fall - financial_aid[0].fall,
            spring: tuition_n_fees[0].spring + housing_n_meal[0].spring + other_expenses[0].spring - financial_aid[0].spring,
        },
        {
            name: "Estimated University Expense",
            fall: tuition_n_fees[0].fall + housing_n_meal[0].fall,
            spring: tuition_n_fees[0].spring + housing_n_meal[0].spring,
        },
        {
            name: "Additional Expenses",
            fall: other_expenses[0].fall,
            spring: other_expenses[0].spring,
        },
        {
            name: "Anticipated Financial Aid",
            fall: financial_aid[0].fall,
            spring: financial_aid[0].spring,
        },
    ]

    return { total, tuition_n_fees, housing_n_meal, other_expenses, financial_aid }
    
}


async function getCostUsingApi(signal, groups) {
    let cost = [{
        name: "Subtotal",
        fall: 0,
        spring: 0,        
    },]

    for(const element of groups){
        if (element.when !== false) 
        {
            try {

                if(element.name_api){
                    const name_res = await request(api(element.name_api), signal, 'GET', undefined, element.name_params)
                    const name_obj = await name_res.json()
                    element.name = name_obj.Name
                }

                const res = await request(api(element.api), signal, 'GET', undefined, element.params)
                const obj = await res.json()

                let fall = 0
                let spring = 0
            
            
                if (element.semester === "Spring") spring = obj.Fee
                else if (element.semester === "Fall") fall = obj.Fee
                else {
                    fall = obj.Fee/2 
                    spring = obj.Fee/2
                }

                cost.push({
                    name: element.name,
                    fall: fall,
                    spring: spring,
                }) 
                cost[0].fall += fall
                cost[0].spring += spring
            
            }
            catch (e) {
                console.error(e)
            } 
        }
        else 
        {
            cost.push({
                name: element.name,
                fall: 0,
                spring: 0,
            })
        }
    }

    return cost
}
async function getCostUsingArray(groups) {
    let cost = [{
        name: "Subtotal",
        fall: 0,
        spring: 0,
    },]

    for(const element of groups){
        let fall = 0
        let spring = 0
        
        for (const item of element.arr){
            const amt = parseFloat(item.amount) 
            if (item.semester === "Spring") spring += amt
            else if (item.semester === "Fall") fall += amt
            else {
                fall += amt/2 
                spring += amt/2
            }
        }

        cost.push({
            name: element.name,
            spring: spring,
            fall: fall,
        }) 
        cost[0].fall += fall
        cost[0].spring += spring
    }

    return cost
}
